import { FC } from 'react';
import { fmtMil, type LinhaComposicao } from '@/utils/equiplexDre';
import { fmtPct } from '@/utils/painelFormat';
import PainelCard from '../PainelCard';

interface Props {
  linhas: LinhaComposicao[];
  cpv: number;
  mesLabel: string;
}

/**
 * O custo dos produtos vendidos aberto pelos grupos do plano de contas do Datasul: o
 * custo de produção do mês por natureza, a absorção pelo estoque e a baixa do estoque
 * vendido. A soma fecha, ao real, com a linha da DRE. O orçado de cada grupo fica só na
 * tabela "Orçado × realizado", que já mostra o mesmo número com o desvio ao lado.
 */
const ComposicaoCustoTable: FC<Props> = ({ linhas, cpv, mesLabel }) => (
  <PainelCard
    testId="dre-composicao"
    titulo={`Composição do custo dos produtos vendidos — ${mesLabel}`}
    subtitulo="Grupos do plano de contas do Datasul, em R$ mil. % da produção = peso de cada natureza no custo de produção do mês. O orçado de cada grupo está em Orçado × realizado."
  >
    <div className="overflow-x-auto">
      <table className="w-full min-w-[480px] text-sm tabular-nums">
        <thead>
          <tr className="border-b border-theme-border text-xs uppercase tracking-wide text-content-muted">
            <th className="py-2 pr-3 text-left font-medium">Grupo</th>
            <th className="px-2 py-2 text-right font-medium">Mês</th>
            <th className="px-2 py-2 text-right font-medium">Média 3 meses</th>
            <th className="px-2 py-2 text-right font-medium">% da produção</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((l) => (
            <tr key={l.key} className="border-b border-theme-border/50">
              <th scope="row" className="py-1.5 pr-3 text-left font-normal text-content-primary">
                {l.rotulo}
              </th>
              <td className="px-2 py-1.5 text-right">{fmtMil(l.valor)}</td>
              <td className="px-2 py-1.5 text-right">{fmtMil(l.media3m)}</td>
              <td className="px-2 py-1.5 text-right">{fmtPct(l.pctDaProducao)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="font-semibold text-content-primary">
            <th scope="row" className="py-2 pr-3 text-left">
              Custo dos produtos vendidos
            </th>
            <td className="px-2 py-2 text-right">{fmtMil(cpv)}</td>
            <td colSpan={2} />
          </tr>
        </tfoot>
      </table>
    </div>
  </PainelCard>
);

export default ComposicaoCustoTable;
